export default __webpack_public_path__ + "static/media/aadhar-front-preview-icon.77bf5846.svg";